import { createAction } from '@reduxjs/toolkit';

export const createQuoteDepositPay = createAction('quoteDepositPay/FETCH_QUOTE_DEPOSIT_PAY');
export const createQuoteDepositPaySuccess = createAction('quoteDepositPay/FETCH_QUOTE_SUCCESS');
export const createQuoteDepositPayFailure = createAction('quoteDepositPay/FETCH_QUOTE_FAILURE');
export const clearQuoteDepositPay = createAction('quoteDepositPay/CLEAR_QUOTE');
export const setQuoteCreated = createAction('quoteDepositPay/SET_QUOTE_CREATED');
